import { lazy, FC, Suspense } from "react";
import { createDefaultConfig, GlobalConfigDefinition } from "@app/core/globalConfig";
import { AppInsightsLoader, reactPlugin } from "./core/insights/azure/AppInsight";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { I18nConfiguration } from "./I18nConfiguration";
import { LoadingProvider } from "@app/core/loading/LoadingContext";
import { DebugOverlay, getDebugLogger } from "@app/core/devtools";
import { ApplicationThemeLoader } from "./core/theme/ApplicationThemeLoader";
import { SyncConfiguration } from "./SyncConfiguration";

const log = getDebugLogger("render:flow");

const Root = lazy(() => import(/* webpackChunkName: "root" */ "@app/Root"));

export const AsyncRoot: FC<{
    baseConfig: GlobalConfigDefinition;
}> = ({ baseConfig }) => {
    const combinedConfig = createDefaultConfig({ ...baseConfig });

    log("AsyncRoot-render", { baseConfig });

    return (
        <SyncConfiguration baseConfig={combinedConfig}>
            <ApplicationThemeLoader>
                <AppInsightsLoader>
                    <AppInsightsContext.Provider value={reactPlugin}>
                        <LoadingProvider>
                            <>
                                <DebugOverlay />
                                <I18nConfiguration>
                                    <Suspense fallback={null}>
                                        <Root />
                                    </Suspense>
                                </I18nConfiguration>
                            </>
                        </LoadingProvider>
                    </AppInsightsContext.Provider>
                </AppInsightsLoader>
            </ApplicationThemeLoader>
        </SyncConfiguration>
    );
};
